import type { MantineThemeOverride } from "@mantine/core";
import type { DefaultTheme } from "styled-components";

declare module "styled-components" {
	export interface DefaultTheme {
		colors: {
			primary: {
				green: string;
				disabled: string;
				black: string;
				darkgrey: string;
				grey: string;
				lightgrey: string;
				white: string;
				blue: string;
				purple: string;
				yellow: string;
				darkText: string;
				darkBackground: string;
				powderBlue: string;
				greyText: string;
			};
			secondary: {
				red: string;
				blue: string;
				lightgreen: string;
				disabled: string;
				yellow: string;
				lightgrey: string;
				grey: string;
				darkgreen: string;
				secondaryGrey: string;
			};
		};
	}
}

export const lightTheme: DefaultTheme = {
	colors: {
		primary: {
			green: "#4AB0A6",
			disabled: "#6CC1B9",
			black: "#1A242D",
			darkgrey: "#4F4F4F",
			grey: "#E4e4e4",
			lightgrey: "#FAFAFA",
			white: "#FFFFFF",
			blue: "#307AD5",
			purple: "#6F5CC9",
			yellow: "#C89720",
			darkBackground: "#25313E",
			darkText: "#2E3B4A",
			powderBlue: "#3F5064",
			greyText: "#8499B1",
		},
		secondary: {
			red: "#FF5A5C",
			blue: "#233984",
			disabled: "#E6E6E6",
			lightgreen: "#CAEF45",
			yellow: "#F5C14F",
			lightgrey: "#F5F5F5",
			secondaryGrey: "#F8F8F8",
			grey: "#E3E2E2",
			darkgreen: "#015E5F",
		},
	},
};

export const mantineThemeOverrides: MantineThemeOverride = {
	colors: {
		green: [
			"#DAE1E0",
			"#C2D0CF",
			"#ABC3C1",
			"#94B9B5",
			"#7CB2AD",
			"#63B0A8",
			"#4AB0A6",
			"#4C958E",
			"#4B807B",
			"#486E6A",
		],
		red: [
			"#E2D3CF",
			"#D6BBB3",
			"#D0A395",
			"#CF8B76",
			"#D47153",
			"#E1562C",
			"#EC3D08",
			"#C0421C",
			"#9E4328",
			"#83422E",
		],
	},
	primaryColor: "green",
};
